import {commonFn} from './common';

/**
 * @description 如果有新增tarot_machine_calculation_type类型，需要在 _orderTypeOptions 字段添加新类型，最后build一下 queryorder 专题，查单页才能查新类型的订单
 * ask_type 订单类型，2才为塔罗算法
 * tarot_machine_calculation_type 塔罗算法类型，1为塔罗算法1，2或3为塔罗算法2，4为塔罗算法3， 5为塔罗算法4（非投放），（已废弃逻辑：3时为塔罗算法2，去到海外假塔罗算法咨询室）
 */

/**
 *	是否塔罗算法2订单+去到海外假塔罗算法咨询室（该需求已下架）
 * @description 该需求已下架
 * @param {object} orderInfo
 * @param {string} orderInfo.ask_type 订单类型
 * @param {number} orderInfo.tarot_machine_calculation_type 塔罗算法类型
 * @returns {boolean}
 */
export function isTarot2ToOStarotChat(orderInfo) {
	return !!(orderInfo.ask_type === 2 && orderInfo.tarot_machine_calculation_type === 3);
}

/**
 *	是否塔罗算法1订单
 * @param {object} orderInfo
 * @param {string} orderInfo.ask_type 订单类型
 * @param {number} orderInfo.tarot_machine_calculation_type 塔罗算法类型
 * @returns {boolean}
 */
export function isTarot1(orderInfo) {
	return !!(
		orderInfo.ask_type === 2 &&
		(orderInfo.tarot_machine_calculation_type === 1 ||
			!orderInfo.tarot_machine_calculation_type)
	);
}

/**
 *	是否塔罗算法2订单
 * @param {object} orderInfo
 * @param {string} orderInfo.ask_type 订单类型
 * @param {number} orderInfo.tarot_machine_calculation_type 塔罗算法类型
 * @returns {boolean}
 */
export function isTarot2(orderInfo) {
	return !!(
		orderInfo.ask_type === 2 &&
		(orderInfo.tarot_machine_calculation_type === 2 ||
			orderInfo.tarot_machine_calculation_type === 3)
	);
}

/**
 * 是否塔罗算法3订单
 * @param {object} orderInfo
 * @param {string} orderInfo.ask_type 订单类型
 * @param {number} orderInfo.tarot_machine_calculation_type 塔罗算法类型
 * @returns {boolean}
 */
export function isTarot3(orderInfo) {
	return !!(orderInfo.ask_type === 2 && orderInfo.tarot_machine_calculation_type === 4);
}

/**
 * 是否塔罗算法4订单
 * @param {object} orderInfo
 * @param {string} orderInfo.ask_type 订单类型
 * @param {number} orderInfo.tarot_machine_calculation_type 塔罗算法类型
 * @returns {boolean}
 */
export function isTarot4(orderInfo) {
	return !!(orderInfo.ask_type === 2 && orderInfo.tarot_machine_calculation_type === 5);
}

/**
 * 订单类型对象
 * @return {array<obj>} 订单类型对象数组
 * @return {object} obj 数组每一项
 * @return {function} obj.check 检查订单类型的方法
 * @return {object} obj.options 订单配置对象
 * @return {string} obj.options.type 订单类型
 * @return {string} obj.options.resultRoute 报告详情页路由
 */
export const _orderTypeOptions = [
	{
		check: isTarot1,
		options: {
			type: 'tarot1',
			resultRoute: '/tarotResult' //报告详情页路由
		}
	},
	{
		check: isTarot2,
		options: {
			type: 'tarot2',
			resultRoute: '/tarot2Result'
		}
	},
	{
		check: isTarot3,
		options: {
			type: 'tarot3',
			resultRoute: '/tarot3Result'
		}
	},
	{
		check: isTarot4,
		options: {
			type: 'tarot4',
			resultRoute: '/tarot4Result'
		}
	}
];

//以下方法和属性不用改
/**
 * 所有塔罗算法报告详情页路由
 */
export const tarotSuanFaRoutes = _orderTypeOptions.map((item) => item.options.resultRoute);

/**
 * 塔罗算法订单（ask_type === 2）返回订单配置对象，否则返回null
 * @param {object} orderInfo 订单详情对象
 * @param {string} orderInfo.ask_type 订单类型
 * @param {number} orderInfo.tarot_machine_calculation_type 塔罗算法类型
 * @return {_orderTypeOptions | null} 订单配置对象
 */
export function getTaluoSuanFaOptions(orderInfo) {
	const orderOptions = _orderTypeOptions.find((item) => item.check(orderInfo));
	return (orderOptions && orderOptions.options) || null;
}

/**
 * 获取塔罗算法链接
 * @param {object} obj 订单详情对象
 * @param {string} obj.ask_type 问答类型，2才为塔罗算法
 * @param {string} obj.tarot_machine_calculation_type 塔罗算法类型
 * @param {string} obj.order_id 订单id
 * @returns {string} 塔罗算法链接，不满足条件返回空字符串
 */
export function getTarotSuanFaHref(obj = {}) {
	const suanFaTypeOption = getTaluoSuanFaOptions(obj);
	if (suanFaTypeOption) {
		const origin = commonFn.isSandbox() ? 'https://sandbox-m.yiqiwen.cn': 'https://m.yiqiwen.cn';
		return `${origin}/dist/csbg${suanFaTypeOption.resultRoute}?order_id=${
			obj.order_id
		}&channel=${commonFn.getChannel()}`;
	}
	return '';
}



// WEBPACK FOOTER //
// ./src/common/js/taluoSuanFaConfig.js